export default __webpack_public_path__ + "static/media/8.02160a49.png";